import { FC } from 'react';
import Pagination from '@mui/material/Pagination';
import { PaginationChangePage } from './PaginationChangePage';
import { PaginationPerPage } from './PaginationPerPage';

interface TablePaginationComponentProps {
  rowsPerPage: number;
  page: number;
  handleChangePage: (event, newPage) => void;
  handleChangePageNumber: (value) => void;
  handleChangeRowsPerPage: (value) => void;
  pages: number;
  total: number;
}

const TablePaginationComponent: FC<TablePaginationComponentProps> = ({
  rowsPerPage,
  page,
  handleChangePage,
  handleChangePageNumber,
  handleChangeRowsPerPage,
  pages,
  total,
}) => {
  return (
    <div className="table-pagination">
      <PaginationPerPage
        rowsPerPage={rowsPerPage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        total={total}
      />
      <Pagination
        className="pagination-pages"
        count={pages}
        page={page + 1}
        onChange={handleChangePage}
        showFirstButton
        showLastButton
        hidePrevButton
        hideNextButton
        color="secondary"
        variant="outlined"
        shape="rounded"
        size="large"
      />
      <PaginationChangePage
        page={page}
        pages={pages}
        handleChangePageNumber={handleChangePageNumber}
      />
    </div>
  );
};

export { TablePaginationComponent };
